import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import "./FirstNavbar.css";

function BrandExample() {
  return (
    <>
      <Navbar className="bg-body-tertiary" id="primanavbar">
        <Container id="firstnavbar">
          <Navbar.Brand href="#home">
            {" "}
            <div className="loghi">
              <div className="primaicona">
                {" "}
                <a href="tel:3339713218">
                  {" "}
                  <img src="./img/Loghi/cellulare.png" alt="" style={{ width: "25px" }}></img>
                </a>
              </div>
              <div className="secondaicona">
                <a href="mailto:fabriziomurru78@gmail.com">
                  <img src="./img/Loghi/email.png" alt="" style={{ width: "25px" }}></img>
                </a>{" "}
              </div>
              <div className="terzaicona">
                <a href="https://www.facebook.com/p/Sa-Domu-e-SOrcu-Ristorante-il-Gufo-100069445907309/">
                  {" "}
                  <img src="./img/Loghi/facebook.png" alt="" style={{ width: "25px" }}></img>
                </a>
              </div>
              <div className="quartaicona">
                <a href="https://www.instagram.com/sadomuesorcu/">
                  {" "}
                  <img src="./img/Loghi/instagram.png" alt="" style={{ width: "25px" }}></img>
                </a>
              </div>
              <div className="quintaicona">
                <a href="https://wa.me/3339713218">
                  {" "}
                  <img src="./img/Loghi/whatsapp.png" alt="" style={{ width: "25px" }}></img>
                </a>{" "}
              </div>{" "}
            </div>{" "}
          </Navbar.Brand>
        </Container>
      </Navbar>
    </>
  );
}

export default BrandExample;
